import { groupBy } from 'lodash-es'

export const filterValuations = (valuations, selectedMonth) => {
  return valuations.filter(
    item =>
      item.monthNumber === selectedMonth.monthNumber &&
      item.year === selectedMonth.year,
  )
}

export const orderValuations = filtered => {
  return filtered.map(month => {
    const daily = groupBy(month.valuations, 'day')
    return Object.entries(daily).sort((a, b) => b[0] - a[0])
  })
}
